import { TokenType } from '@d24/demarked';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
/**
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
export class PaywallAdapter {
    /**
     * @inheritDoc
     */
    objectToToken() {
        return {
            content: '#PAYWALL',
            raw: '#PAYWALL',
            type: TokenType.Paywall
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject() {
        return {
            ...getModuleBase(),
            content: {},
            driver: ModuleDriver.Paywall
        };
    }
}
